"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const UiKitLite_1 = require("../UiKitLite");
const ColorDescription = (props) => {
    return (react_2.default.createElement(react_1.HStack, { w: '200px', p: 0, spacing: UiKitLite_1.UiKitLite.consistency.buffer },
        react_2.default.createElement(react_1.Box, { backgroundColor: props.hexCode, w: '40px', h: '40px', borderRadius: UiKitLite_1.UiKitLite.consistency.borderRadius }, "\u00A0"),
        react_2.default.createElement(react_1.VStack, { align: 'flex-start' },
            react_2.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, props.name),
            react_2.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, { color: UiKitLite_1.UiKitLite.consistency.gray70 }, props.hexCode))));
};
const Colors = () => {
    const allColors = UiKitLite_1.UiKitLite.consistency.allColors();
    const commonPrefixes = ['primary', 'success', 'info', 'warning', 'error', 'accent', 'data', 'gray'];
    const entryGroups = [];
    for (let i = 0; i < commonPrefixes.length; i++) {
        const commonPrefix = commonPrefixes[i];
        const colorsWithThisPrefix = allColors.filter(color => {
            return color.name.startsWith(commonPrefix);
        });
        if (colorsWithThisPrefix.length) {
            entryGroups.push({
                label: commonPrefix,
                colors: colorsWithThisPrefix,
            });
        }
    }
    const colorsWithoutACommonPrefix = allColors.filter(color => {
        const matchesForEachPrefix = commonPrefixes.map(prefix => {
            return color.name.startsWith(prefix);
        });
        return !matchesForEachPrefix.includes(true);
    });
    if (colorsWithoutACommonPrefix.length) {
        entryGroups.push({
            label: 'other',
            colors: colorsWithoutACommonPrefix,
        });
    }
    return (react_2.default.createElement(react_1.Wrap, { shouldWrapChildren: true, align: 'flex-start', spacing: UiKitLite_1.UiKitLite.consistency.buffer }, entryGroups.map((group, index) => {
        return (react_2.default.createElement(react_1.VStack, { align: 'flex-start', key: `entries-${index}`, spacing: UiKitLite_1.UiKitLite.consistency.buffer },
            react_2.default.createElement(react_1.VStack, { width: '100%', align: 'flex-start', borderBottom: `2px solid ${UiKitLite_1.UiKitLite.consistency.primaryBlue50}`, p: `${UiKitLite_1.UiKitLite.consistency.halfBuffer} 0` },
                react_2.default.createElement(UiKitLite_1.UiKitLite.Text.Heading2, { text: group.label }),
                react_2.default.createElement(UiKitLite_1.UiKitLite.Text.BodySmall, null,
                    react_2.default.createElement("span", { style: {
                            fontSize: '10px',
                            fontFamily: 'monospace',
                        } }, "UiKit.consistency."),
                    react_2.default.createElement("b", null, group.colors[0].name))),
            group.colors.map(color => {
                return react_2.default.createElement(ColorDescription, { key: color.name, name: color.name, hexCode: color.hexCode });
            })));
    })));
};
exports.Colors = Colors;
